export default __webpack_public_path__ + "static/location-map-tablet-c62a56537f91e18f8b685b945cf5e0a6.jpg";